import { useEffect, useState } from "react";
import Distinctions from "./components/Distinctions"
import ForumSection from "./components/ForumSection";
import LessonsCarousel from "./components/Lessons"
import { useLocation } from "react-router-dom";
import AppTour from "../../../components/AppTour/AppTour";
import { resourceLibraryTourSteps } from "../../../components/AppTour/ModuleTourSteps";
import InterviewsAndGuides from "./components/InterviewsAndGuides";
import { useTrackFirstVisit, ACTIVITY_TYPES } from "../../../hooks/useTrackFirstVisit";
import { useTrackModuleVisit, MODULE_VISIT_TYPES } from "../../../hooks/useTrackModuleVisit";

const ResourceLibrary = () => {
    const [runTour, setRunTour] = useState(false)
    const { hash } = useLocation()

    useTrackFirstVisit(ACTIVITY_TYPES.PROFESSORU_RESOURCE_LIBRARY_FIRST_VISIT);
    useTrackModuleVisit(MODULE_VISIT_TYPES.PROFESSORU, "resource-library");

    useEffect(() => {
        if (hash === "#start-tour") {
            setRunTour(true)
        }
    }, [hash])
    return (
        <div className="DataAnalyst-page py-5">
            <AppTour
                tourSteps={resourceLibraryTourSteps}
                runTour={runTour}
                setRunTour={setRunTour}
                tourName="professoru-resource-library"
                moduleId="professoru-resource-library"
            />
            <div className="container max-w-full">
                <Distinctions
                    title={"Resource Library"}
                    inputPlaceholder={"What do you want to achieve right now?"}
                    resourceButton={false}
                />
                <div data-tour="walkthrough-guides">
                    <InterviewsAndGuides title={"Walkthrough Guides"} type="guide" />
                </div>
                <div data-tour="troubleshooting-guides">
                    <InterviewsAndGuides title={"Troubleshooting Guides"} type="troubleshooting" />
                </div>
                <ForumSection />
            </div>
        </div>
    )
}

export default ResourceLibrary